// extracted by mini-css-extract-plugin
module.exports =  {"root":"jkvFVvjqxf53kIkaZFfU"};